import { Breadcrumb, Select, Input, InputNumber } from "antd";
import { t } from "i18next";
import { BackIcon } from "../../../../asset";
import React, { useState } from 'react';
import style from './palletPage.module.css'
import ConfirmationModal from "../../../../component/modal/ConfirmationModal";
import SuccessModal from "../../../../component/modal/SuccessModal";
import { useNavigate } from "react-router";
import { ROUTES } from "../../../../constant/routeConstant";
import TextArea from "antd/es/input/TextArea";
import { usePallet } from "./PalletPage.hooks";
import Breadcumbs from '../../../../component/page-components/breadcumbs/breadcumbs';
import ModalConfirmLeave from "../../../../component/modal/ModalConfirmLeave";
import { useLocation } from "react-router-dom";

export default function PalletAdd() {

    const {state} = useLocation()

    const {
        successModalOpen,
        setSuccessModalOpen,
        toListPallet,
        onChange,
        palletName,
        doPostPallet,
        setShowConfirm,
        showConfirm,
        isClear,
        palletNameError,
        palletDescriptionError,
        palletWeightError,
        palletLengthError,
        setPalletLengthError,
        palletHeightError,
        setPalletHeightError,
        palletWidthError,
        setPalletWidthError
    } = usePallet();

    return (
        <div className='p-[24px] flex flex-col gap-[24px]'>

            <ModalConfirmLeave
                visible={showConfirm}
                action={() => setShowConfirm(false)}
                route={ROUTES.PALLET.LIST}
            />

            <SuccessModal
                isOpen={successModalOpen}
                onOk={toListPallet}
                closable={false}
                width={280}
                className={style.successModal}
                okText="Ok"
                title="Success"
                description={`${palletName} has been added`}
            />

            <Breadcumbs
                jmlLevel={4}
                menuLevel1={`Master`}
                menuLevel2={`Fleet`}
                menuLevel3={`Pallet`}
                menuLevel4={`Add Pallet`}
            />

            <div className="flex items-center gap-[22px] cursor-pointer" onClick={!isClear() ? () => setShowConfirm(true) : () => toListPallet()}>
                <img src={BackIcon} alt="back-icon" />
                <h1 className='font-sans-bold text-2xl' id='title'>{t("PALLET_ADD:TITLE")}</h1>
            </div>

            <div className="border-[#DDDDDD] bg-white-100 rounded-[10px] border-[1px] px-[30px] py-[24px] flex gap-[200px]">
                <div>
                    <h3 className="font-roboto font-medium mb-[16px] text-lg">{t("PALLET_ADD:PALLET_INFORMATION")}</h3>

                    <div className="flex flex-col gap-[16px]">
                        <div className="flex flex-col">
                            <label className="font-roboto font-medium text-md">{t("PALLET_ADD:PALLET_NAME_FIELD")}</label>
                            <Input style={{ width: 350 }} className='mt-[8px]' maxLength={30} placeholder={t("PALLET_ADD:PALLET_NAME_PLACEHOLDER")} onChange={(event) => onChange(event, 'pallet_name')} />
                            <p className={`font-[12px] mt-[8px] text-[#FF0000] font-roboto ${palletNameError ? `visible` : `hidden`}`}>This field is required</p>
                        </div>
                        <div className="flex flex-col">
                            <label className="font-roboto font-medium text-md">{t("PALLET_ADD:DESCRIPTION_PALLET_FIELD")}</label>
                            <TextArea
                                style={{ width: 350, resize: 'none' }}
                                placeholder={t("PALLET_ADD:DESCRIPTION_PALLET_PLACEHOLDER")}
                                onChange={(event) => onChange(event, 'pallet_description')}
                                maxLength={256}
                            />
                            <p className={`font-[12px] mt-[8px] text-[#FF0000] font-roboto ${palletDescriptionError ? `visible` : `hidden`}`}>This field is required</p>
                        </div>
                    </div>
                </div>
                <div>
                    <h3 className="font-roboto font-medium mb-[16px] text-lg">{t("PALLET_ADD:PALLET_SPECIFICATION")}</h3>

                    <div className="flex flex-col gap-[16px]">
                        <div className="flex flex-col">
                            <label className="font-roboto font-medium text-md">{t("PALLET_ADD:WEIGHT_FIELD")}</label>
                            <InputNumber min="0" controls={false} className='w-[242px]' onChange={(event) => onChange(event, 'weight')} placeholder='0' addonAfter={<div className='text-[#818181]'>Kg</div>} />
                            <p className={`font-[12px] mt-[8px] text-[#FF0000] font-roboto ${palletWeightError ? `visible` : `hidden`}`}>This field is required</p>
                        </div>
                        <div className="flex flex-col">
                            <label className="font-roboto font-medium text-md">{t("PALLET_ADD:LENGHT_FIELD")}</label>
                            <InputNumber min="0" controls={false} className='w-[242px]' onChange={(event) => onChange(event, 'length')} placeholder='0' addonAfter={<div className='text-[#818181]'>M</div>} />
                            <p className={`font-[12px] mt-[8px] text-[#FF0000] font-roboto ${palletLengthError ? `visible` : `hidden`}`}>This field is required</p>
                        </div>
                        <div className="flex flex-col">
                            <label className="font-roboto font-medium text-md">{t("PALLET_ADD:HEIGHT_FIELD")}</label>
                            <InputNumber min="0" controls={false} className='w-[242px]' onChange={(event) => onChange(event, 'height')} placeholder='0' addonAfter={<div className='text-[#818181]'>M</div>} />
                            <p className={`font-[12px] mt-[8px] text-[#FF0000] font-roboto ${palletHeightError ? `visible` : `hidden`}`}>This field is required</p>
                        </div>
                        <div className="flex flex-col">
                            <label className="font-roboto font-medium text-md">{t("PALLET_ADD:WIDTH_FIELD")}</label>
                            <InputNumber min="0" controls={false} className='w-[242px]' onChange={(event) => onChange(event, 'width')} placeholder='0' addonAfter={<div className='text-[#818181]'>M</div>} />
                            <p className={`font-[12px] mt-[8px] text-[#FF0000] font-roboto ${palletWidthError ? `visible` : `hidden`}`}>This field is required</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="flex flex-row-reverse justify-start gap-[16px]">
                <button className="bg-[#CF0000] font-medium rounded-[6px] w-[96px] h-[44px] text-white-100 font-sans text-[18px]" onClick={() => doPostPallet(state.depotId)}>
                    {t("PALLET_ADD:ADD_BUTTON")}
                </button>
                <button className="border-[2px] border-[#CF0000] font-medium rounded-[6px] w-[96px] h-[44px] text-[#CF0000] font-sans text-[18px]" onClick={!isClear() ? () => setShowConfirm(true) : () => toListPallet()}>
                    {t("PALLET_ADD:CANCEL_BUTTON")}
                </button>
            </div>

        </div>
    )
}